import React from 'react'
import Select from "react-select";
import { components } from 'react-select';
import { CircularAvatar } from '../../commons';
import { LoginResponseType } from '../../../redux/auth/authTypes';

type AppProps = {
    jobsData: any;
    jobsError:any;
    userFetching:boolean;
    setoffset:any;
    setText:any;
    type?:string;
    recurringData:any;
    checkBottom:()=>void;
    handleChange: (data: any, name: string) => void;
    finalManagerList: any;
    finalUserList: any;
    finalPartnerList: any;
    managerFetching:boolean;
    setManagerOffset:(e:any)=>void;
    checkManagerBottom:()=>void;
    setManagerText:(e:any)=>void;
    partnerFetching:boolean;
    setPartnerOffset:(e:any)=>void;
    checkPartnerBottom:()=>void;
    setPartnerText:(e:any)=>void;
    recurringResponsiblePeople:any;
    singlejobsData:any;
    loginData?:LoginResponseType;
    OfficerFetching: boolean;
    setGovtOffset: React.Dispatch<React.SetStateAction<number>>;
    checkGovtBottom: () => void;
    setGovtText: React.Dispatch<React.SetStateAction<string>>;
    finalGovtOfficerList: any;
}


const Option = (props: any) => {
    const { data } = props;
    return (
        <components.Option {...props} >
            <div className='d-flex justify-content-sm-start' style={{ gap: '10px' }}>
                <CircularAvatar name={data?.label.split("%")[0]} image={data?.image && data?.image} />
                <div style={{ marginTop: "-3px" }}>
                    <span style={{ fontWeight: "500", fontSize: "16px" }}>{data?.label.split("%")[0]}</span>
                    <br></br>
                    <span style={{ color: "#6e7491" }}>{data?.label.split("%")[1]}</span>
                </div>
            </div>
        </components.Option>
    );
};



const TeamInfo = ({
    jobsData,
    jobsError,
    handleChange,
    finalManagerList,
    finalUserList,
    finalPartnerList,
    userFetching,
    setoffset,
    setText,
    loginData,
    checkBottom,
    managerFetching,
    setManagerOffset,
    checkManagerBottom,
    setManagerText,
    partnerFetching,
    setPartnerOffset,
    checkPartnerBottom,
    setPartnerText,
    singlejobsData,
    OfficerFetching,
    setGovtOffset,
    checkGovtBottom,
    setGovtText,
    finalGovtOfficerList,
}: AppProps) => {
    
    return (
        <div>

            <div className='row'>
                <div className="col-md-3"> <label>Currently Responsible<span className='color-red'>*</span></label>
                    <div className='mt-1'>
                        <Select
                            className="dropdown"
                            placeholder={"Search User"}
                            value={jobsData?.currResponsible ? jobsData?.currResponsible : ""}
                            options={finalUserList}
                            components={{ Option }}
                            onChange={(e: any) => handleChange(e, "currResponsible")}
                            isSearchable={true}
                            isLoading={userFetching}
                            onMenuClose={() => { setoffset(0) }}
                            onMenuScrollToBottom={checkBottom}
                            onInputChange={(e) => {
                                setText(e)
                            }}
                            isDisabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                        />
                         <div>{!!jobsError?.currResponsible && <small className="text-danger">{jobsError?.currResponsible}</small>}</div>
                    </div></div>
                <div className="col-md-3"> <label>Job Manager<span className='color-red'>*</span></label>
                    <div className='mt-1'>
                        <Select
                            className='dropdown'
                            options={finalManagerList}
                            value={jobsData?.jobManager ? jobsData?.jobManager : ""}
                            components={{ Option }}
                            onChange={(e) => handleChange(e, "jobManager")}
                            isSearchable={true}
                            isLoading={managerFetching}
                            onMenuClose={() => { setManagerOffset(0) }}
                            onMenuScrollToBottom={checkManagerBottom}
                            onInputChange={(e) => {
                                setManagerText(e)
                            }}
                            isDisabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                        />
                         <div>{!!jobsError?.jobManager && <small className="text-danger">{jobsError?.jobManager}</small>}</div>
                    </div></div>
                <div className="col-md-3"> <label>Job Partner</label>
                    <div className='mt-1'>
                        <Select
                            className="dropdown"
                            placeholder={"Search User"}
                            value={jobsData?.jobPartner ? jobsData?.jobPartner :""}
                            options={finalPartnerList}
                            components={{ Option }}
                            onChange={(e: any) => handleChange(e, "jobPartner")}
                            isSearchable={true}
                            isLoading={partnerFetching}
                            onMenuClose={() => { setPartnerOffset(0) }}
                            onMenuScrollToBottom={checkPartnerBottom}
                            onInputChange={(e) => {
                                setPartnerText(e)
                            }}
                            isDisabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                        />
                    </div></div>
                    <div className="col-md-3"> <label>Officer</label>
                    <div className='mt-1'>
                        <Select
                            className="dropdown"
                            placeholder={"Search User"}
                            value={jobsData?.govtOfficer ? jobsData?.govtOfficer : ""}
                            options={finalGovtOfficerList}
                            components={{ Option }}
                            onChange={(e: any) => handleChange(e, "govtOfficer")}
                            isSearchable={true}
                            isLoading={OfficerFetching}
                            onMenuClose={() => { setGovtOffset(0) }}
                            onMenuScrollToBottom={checkGovtBottom}
                            onInputChange={(e) => {
                                setGovtText(e)
                            }}
                            isDisabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                        />
                    </div></div>

            </div>

        </div>
    )
}

export default TeamInfo